import { render, staticRenderFns } from "./DashboardStepGroupRepetitionNotification.vue?vue&type=template&id=b9406b24&scoped=true&"
import script from "./DashboardStepGroupRepetitionNotification.vue?vue&type=script&lang=js&"
export * from "./DashboardStepGroupRepetitionNotification.vue?vue&type=script&lang=js&"
import style0 from "./DashboardStepGroupRepetitionNotification.vue?vue&type=style&index=0&id=b9406b24&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9406b24",
  null
  
)

/* custom blocks */
import block0 from "./DashboardStepGroupRepetitionNotification.vue?vue&type=custom&index=0&blockType=translations"
if (typeof block0 === 'function') block0(component)

export default component.exports